import React from "react";
import { useForm, useFieldArray } from "react-hook-form";
import {
  TextField,
  Button,
  Stack,
  Box,
  IconButton,
  useTheme,
  Typography,
  Card,
} from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import DeleteIcon from "@mui/icons-material/Delete";

interface ArrayInputFieldProps {
  label: string;
  values: string[];
  onChange: (values: string[]) => void;
  placeholder?: string;
}

const ArrayInputField: React.FC<ArrayInputFieldProps> = ({
  label,
  values,
  onChange,
  placeholder,
}) => {
  const theme = useTheme();
  const { control, handleSubmit } = useForm({
    defaultValues: {
      items: values.map((value) => ({ value })),
    },
  });

  const { fields, append, remove } = useFieldArray({
    control,
    name: "items",
  });

  const onSubmit = (data: { items: { value: string }[] }) => {
    // debugger;
    onChange(data.items.map((item) => item.value));
  };

  return (
    <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ p: 0, m: 0 }}>
      <Typography variant="subtitle2" gutterBottom>
        {label}
      </Typography>
      <Card variant="outlined" sx={{ p: 2 }}>
        <Stack spacing={1.5}>
          {fields.map((field, index) => (
            <Stack
              key={field.id}
              direction="row"
              spacing={1}
              alignItems="center"
            >
              <TextField
                fullWidth
                size="small"
                {...control.register(`items.${index}.value`)}
                placeholder={placeholder}
                sx={{ flex: 1 }}
                onBlur={(e) => {
                  const newValues = [...fields.map((f) => f.value)];
                  newValues[index] = e.target.value;
                  onChange(newValues);
                }}
                onFocus={(e) => e.target.select()}
              />
              <IconButton
                onClick={() => remove(index)}
                color="error"
                size="small"
              >
                <DeleteIcon fontSize="small" />
              </IconButton>
            </Stack>
          ))}
          {fields.length < 4 && (
            <IconButton
              onClick={() => {
                append({ value: "" });
                handleSubmit(onSubmit)();
              }}
              size="small"
              sx={{
                alignSelf: "flex-start",
                color: theme.palette.primary.main,
                border: `1px solid ${theme.palette.primary.main}`,
                borderRadius: 1,
                p: 0.5,
                "&:hover": {
                  backgroundColor: theme.palette.primary.light,
                  color: theme.palette.primary.contrastText,
                },
              }}
            >
              <AddIcon fontSize="small" sx={{ mr: 0.5 }} />
              <Typography variant="caption">Add {label}</Typography>
            </IconButton>
          )}
        </Stack>
      </Card>
    </Box>
  );
};

export default ArrayInputField;
